import { render, staticRenderFns } from "./Submenu2.vue?vue&type=template&id=3ee39034&scoped=true&"
import script from "./Submenu2.vue?vue&type=script&lang=js&"
export * from "./Submenu2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee39034",
  null
  
)

export default component.exports